import React, { useCallback, useEffect, useState } from 'react'

export const PasswordReveal = ({ inputId }: { inputId: string }) => {
  const [type, setType] = useState('password')
  const toggleType = useCallback(() => setType((old) => (old === 'password' ? 'text' : 'password')), [setType])
  useEffect(() => {
    const input = document.getElementById(inputId) as HTMLInputElement | null
    if (input) {
      input.type = type
    }
  }, [type, inputId])

  return (
    <button
      type="button"
      className={`password-reveal-icon fa fa-${type == 'text' ? 'eye-slash' : 'eye'}`}
      onClick={toggleType}
    />
  )
}
